import type { DocNode } from '../components/DocContent';

export type DocGroup = DocNode | DocNode[];

export function groupImageRuns(nodes: DocNode[]): DocGroup[] {
    return nodes.reduce<DocGroup[]>((groups, node) => {
        if (node.type !== 'image') return [...groups, node];
        const last = groups[groups.length - 1];
        return Array.isArray(last)
            ? [...groups.slice(0, -1), [...last, node]]
            : [...groups, [node]];
    }, []);
}
